import { v4 as uuidv4 } from 'uuid';
import { List } from 'immutable';

import { categoriesTypes } from 'companion-app-components/flux/categories';
import { ChartOfAccount } from 'companion-app-components/flux/chart-of-accounts/chartOfAccountsTypes';
import { CategoryType } from 'companion-app-components/flux/categories/categoriesTypes';

export type CategoryGroupsPayload = {
  clientId: string;
  name: string;
  categoryGroupListId: string;
  isNotEditable: boolean;
  coas?: List<ChartOfAccount>;
  type: CategoryType;
  isDeleted: boolean;
};

const categoryGroupMainTypes = [{
  name: 'Personal Income',
  type: categoriesTypes.CategoryTypeEnum.INCOME,
  coa: categoriesTypes.CategoryTypeEnum.INCOME,
}, {
  name: 'Personal Expenses',
  type: categoriesTypes.CategoryTypeEnum.EXPENSE,
  coa: categoriesTypes.CategoryTypeEnum.EXPENSE,
}, {
  name: 'Business Income',
  type: categoriesTypes.CategoryTypeEnum.INCOME,
  coa: null,
}, {
  name: 'Business Expenses',
  type: categoriesTypes.CategoryTypeEnum.EXPENSE,
  coa: null,
}, {
  name: 'Rental Property Income',
  type: categoriesTypes.CategoryTypeEnum.INCOME,
  coa: null,
}, {
  name: 'Rental Property Expenses',
  type: categoriesTypes.CategoryTypeEnum.EXPENSE,
  coa: null,
}];

export const getCreateCategoryGroupsPayload = (allIncomeCategories, allExpenseCategories, categoryGroupListId) => {
  const payload = categoryGroupMainTypes.map(({ name, type, coa }) => {
    const data: CategoryGroupsPayload = {
      name,
      type,
      categoryGroupListId,
      isDeleted: false,
      isNotEditable: true,
      clientId: uuidv4(),
    };
    if (coa === categoriesTypes.CategoryTypeEnum.INCOME) {
      data.coas = allIncomeCategories?.map((categoryId) => ({
        id: categoryId,
        type: 'CATEGORY',
      }));
    } else if (coa === categoriesTypes.CategoryTypeEnum.EXPENSE) {
      data.coas = allExpenseCategories?.map((categoryId) => ({
        id: categoryId,
        type: 'CATEGORY',
      }));
    }
    return data;
  });
  return payload;
};
